import { buildSchema,buildProperty } from "@camberi/firecms";

export const workoutCategoriesSchema = buildSchema({
    name: "Workout Categories",
    properties: {
        categoryName: {
            title: "categoryName",
            dataType: "string",
            validation: { required: true },
        },
        description: {
            title: "description",
            dataType: "string",
            config: {
                markdown: true
            },
            validation: { required: true },
        },
        thumbnail: buildProperty({
            title: "Thumbnail Image",
            dataType: "reference",
            path: "media",
            previewProperties: ["mediaUrl"]
            // dataType: "string",
            // validation: { required: true },
            // config: {
            //     storageMeta: {
            //         mediaType: "image",
            //         storagePath: "images",
            //         acceptedFiles: ["image/*"],
            //         storeUrl: true,
            //         metadata: {
            //             cacheControl: "max-age=1000000"
            //         }
            //     }
            // }
        }),
        order: {
            title: "Order",
            dataType: "number",
            validation: { required: true },
        },
        tags: buildProperty({
            title: "Tags",
            description: "Tags",
            validation: { required: true },
            dataType: "array",
            of: {
                dataType: "string",
                config: {
                    previewAsTag: true
                }
            }
        }),
        status: {
            title: "status",
            dataType: "boolean"
        },
        createdAt: {
            title: "createdAt",
            dataType: "timestamp",
            validation: { required: true },
        },
    },
    defaultValues: {
        status: false
    }
});
